import { create_product_order } from '@/sub-luca-plugin/apis';

export const defaultOrderPay = {
    payChannelType: 'cashier',
    payChannel: 'Wechat',
    payType: '148',
};

export const handleCreactOrder = async (productId: number, orderPay: any, orderSource?: number) => {
    // 创建用户订单
    const res = await create_product_order({
        // studentId: stringify;
        orderSource: orderSource || 1000442,
        clueParameters: '{"lucaOrder":true}',
        productId,
        appId: 'wx4f1fcbd78ee2b420',
        orderPay,
        productType: 'serviceProduct',
    });
    if (res.status === 0) {
        return res.result;
    }
    throw res.message;
};
